export default function About() {
  const years = new Date().getFullYear() - 2010;

  return (
    <section className="sec" id="about">
      <div className="wrap about-grid">
        <div className="about-media">
          <img
            className="about-img"
            src={`${process.env.PUBLIC_URL}/assets/IMG_7962-01.jpeg`}
            alt="Αίθουσα φροντιστηρίου"
          />
          <div className="badge">
            <div className="y">{years}</div>
            <div className="t">χρόνια εμπειρίας</div>
          </div>
        </div>
        <div className="about-text">
          <p className="eyebrow">Το φροντιστήριό μας</p>
          <h2>Εμπειρία που γίνεται μέθοδος.</h2>
          <p>
            Το φροντιστήριο <strong>Πράξη</strong> ιδρύθηκε το 2010 από μια ομάδα
            καθηγητών με μακρόχρονη εμπειρία στην ιδιωτική και δημόσια
            εκπαίδευση. Η ανάγκη για καινοτομία μάς οδήγησε να προσφέρουμε
            υψηλής ποιότητας υπηρεσίες στους μαθητές μας.
          </p>
          <p>
            Το αποτέλεσμα; <strong>Πρωτιές κάθε χρόνο στο νομό Λέσβου</strong>{' '}
            και υψηλά ποσοστά επιτυχόντων στις πρώτες τους επιλογές.
          </p>
          <ul className="about-points" style={{ listStyle: 'none', padding: 0 }}>
            <li>
              <span className="ck">✓</span> Καθηγητές με αποδεδειγμένη εμπειρία
              σε κάθε μάθημα
            </li>
            <li>
              <span className="ck">✓</span> Προσωπική παρακολούθηση της πορείας
              κάθε μαθητή
            </li>
            <li>
              <span className="ck">✓</span> Σταθερή επικοινωνία με τους γονείς
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
